import VerticalTable from "@components/VerticalTable"
import { getCoefficientRows } from "@features/graph/details/components/DeterministicNodeDetails/helpers"
import { Typography } from "@mui/material"

type CoefficientsTableProps = {
  expression: string
  editable?: boolean
  onBlur: (coefficient: string, newValue: number) => void
}

const CoefficientsTable = ({ expression, editable = false, onBlur }: CoefficientsTableProps) => {
  const rows = getCoefficientRows(expression, { editable, onBlur })
  if (rows.length > 0) return <VerticalTable headers={["Coefficient", "Value"]} rows={rows} />
  else
    return (
      <Typography>
        <i>No editable coefficients in expression</i>
      </Typography>
    )
}

export default CoefficientsTable
